const API = '/api';

// Refdata URLs
export const TVA_VALUES_URL = '/refdata/tva';
export const LANGUAGES_URL = '/refdata/languages';
export const APP_CONFIGURATION_URL = '/refdata/config';
export const ODITOO_PACKS_URL = '/refdata/packs/oditoo';
export const TRANSLATIONS_URL = '/refdata/translations';
export const SELF_SERVICE_THEMES_URL = '/refdata/themes';
export const STATUS_URL = '/refdata/interventions/status';
export const FLEETBACK_PACKS_URL = '/refdata/packs/fleetback';
export const AUDIT_MODELS_FIELDS_URL = '/refdata/auditModels/fields';
export const SELF_SERVICE_WORKFLOW = '/refdata/selfServices/workflows';
export const DEFAULT_CLIPPING_MEDIAS_URL = '/refdata/clippingBackgroundImages';

// Appointments URLs
const APPOINTMENTS_URL = '/appointments';
export const APPOINTMENTS_API_URL = `${APPOINTMENTS_URL}${API}`;
export const APPOINTMENTS_ATTENTION_POINTS_URL = `${APPOINTMENTS_API_URL}/attentionPoints`;
const APPOINTMENT_TASKS_URL = '/appointmentTasks';
export const APPOINTMENT_TASKS_API_URL = `${APPOINTMENT_TASKS_URL}${API}`;
export const APPOINTMENT_TASK_EVENTS_FILTER_URL = 'appointmentTaskEvents/filter';

// Audit & AuditModels URLs
export const AUDITS_URL = '/audits';
export const AUDITS_API_URL = `${AUDITS_URL}${API}`;
export const AUDITS_FILTER_URL = `${AUDITS_URL}/filter`;
export const AUDITS_API_FILTER_URL = `${AUDITS_API_URL}/filter`;
export const AUDIT_MODELS_URL = '/auditModels';
export const AUDIT_MODELS_API_URL = `${AUDIT_MODELS_URL}${API}`;
export const AUDIT_STATISTICS_URL = '/auditStatistics';
const AUDIT_STATISTICS_API_URL = `${AUDIT_STATISTICS_URL}${API}`;
export const AUDIT_STATISTICS_EXPORT_URL = `${AUDIT_STATISTICS_API_URL}/export`;
export const AUDIT_STATISTICS_REDUCE_URL = `${AUDIT_STATISTICS_URL}/reduce`;
export const AUDIT_FILE_STATISTICS_URL = '/auditFileStatistics';
const AUDIT_FILE_STATISTICS_API_URL = `${AUDIT_FILE_STATISTICS_URL}${API}`;
export const AUDIT_FILE_STATISTICS_TABLE_URL = `${AUDIT_FILE_STATISTICS_API_URL}/table`;
export const AUDIT_FILE_STATISTICS_SUMMARY_URL = `${AUDIT_FILE_STATISTICS_API_URL}/summary`;
export const LATEST_AUDIT_MODELS_URL = '/latestAuditModels';
export const LATEST_AUDIT_MODELS_API_URL = `${LATEST_AUDIT_MODELS_URL}${API}`;
export const LATEST_AUDIT_MODELS_SEARCH_AVAILABLE_URL = `${LATEST_AUDIT_MODELS_URL}/search/available`;
export const LATEST_AUDIT_MODELS_SEARCH_MY_AUDIT_MODELS_URL = `${LATEST_AUDIT_MODELS_URL}/search/myAuditModels`;

// Billing URLs
const BILLING_URL = '/billing';
export const BILLING_API_URL = `${BILLING_URL}${API}`;

// Brands & Branding URLs
export const BRANDS_URL = '/brands';
export const ALL_BRANDS_URL = `${BRANDS_URL}/all`;
export const BRANDS_FILTER_URL = `${BRANDS_URL}/filter`;
const BRANDING_TEMPLATES_URL = '/brandingTemplates';
export const BRANDING_TEMPLATES_FILTER_URL = `${BRANDING_TEMPLATES_URL}/filter`;

// Campaigns & Contact Lists URLs
const CAMPAIGNS_URL = '/campaigns';
export const CAMPAIGNS_API_URL = `${CAMPAIGNS_URL}${API}`;
const CAMPAIGNS_FILES_URL = '/campaignFiles';
export const CAMPAIGNS_FILES_FILTER_URL = `${CAMPAIGNS_FILES_URL}/filter`;
const CONTACT_LISTS_URL = '/contactLists';
export const CONTACT_LISTS_API_URL = `${CONTACT_LISTS_URL}${API}`;
export const CONTACT_LISTS_FILTER_URL = `${CONTACT_LISTS_API_URL}/filter`;
export const CONTACT_LISTS_TEMPLATE_DOWNLOAD_URL = `${CONTACT_LISTS_API_URL}/template/download`;

// Chat & Messaging URLs
const CONVERSATIONS_URL = '/conversations';
export const CONVERSATIONS_API_URL = `${CONVERSATIONS_URL}${API}`;
export const CONVERSATIONS_FILTER_URL = `${CONVERSATIONS_API_URL}/filter`;
export const CONVERSATIONS_COUNTS_URL = `${CONVERSATIONS_API_URL}/counts`;
const MESSAGES_URL = '/messages';
export const MESSAGES_API_URL = `${MESSAGES_URL}${API}`;
export const MESSAGES_FILTER_URL = `${MESSAGES_API_URL}/filter`;
export const CHAT_STATISTICS_URL = '/messageStatistics';
export const PREDEFINED_MESSAGES_URL = '/predefinedMessages';
export const PREDEFINED_MESSAGES_API_URL = `${PREDEFINED_MESSAGES_URL}${API}`;
export const PREDEFINED_MESSAGES_FILTER_URL = `${PREDEFINED_MESSAGES_URL}/filter`;
export const PREDEFINED_MESSAGES_SEARCH_BY_DEALER_OR_GROUP_URL = `${PREDEFINED_MESSAGES_URL}/search/findByDealerIdOrGroupId`;
export const WHATSAPP_ACCOUNTS_URL = '/whatsAppAccounts';

// Checklists URLs
export const CHECKLISTS_URL = '/checklists';
export const CHECKLISTS_API_URL = `${CHECKLISTS_URL}${API}`;
export const CHECKLISTS_FILTERS_URL = `${CHECKLISTS_API_URL}/filters`;
export const CHECK_LIST_ADVICE_STATISTICS_URL = '/checklistAdviceStatistics';
export const CHECKLISTS_SEARCH_AVAILABLE_URL = `${CHECKLISTS_URL}/search/available`;
export const CHECKLISTS_SEARCH_BY_DEFAULT_URL = `${CHECKLISTS_URL}/search/byDefault`;
export const CHECKLISTS_SEARCH_ALTERABLE_URL = `${CHECKLISTS_API_URL}/search/alterable`;
export const CHECKLISTS_SEARCH_AVAILABLE_API_URL = `${CHECKLISTS_API_URL}/search/available`;
export const CHECK_LIST_ADVICE_STATISTICS_REDUCE_URL = `${CHECK_LIST_ADVICE_STATISTICS_URL}/reduce`;

// Countries URLs
const COUNTRIES_URL = '/countries';
const COUNTRIES_API_URL = `${COUNTRIES_URL}${API}`;
export const ALL_COUNTRIES_URL = `${COUNTRIES_API_URL}/all`;

// Customers URLs
export const CUSTOMERS_URL = '/customers';
export const CUSTOMERS_API_URL = `${CUSTOMERS_URL}${API}`;
export const CUSTOMERS_FILTER_URL = `${CUSTOMERS_URL}/filter`;

// Dealers URLs
export const DEALERS_URL = '/dealers';
export const DEALERS_API_URL = `${DEALERS_URL}${API}`;
export const DEALERS_FILTER_URL = `${DEALERS_URL}/filter`;
export const DEALERS_NAME_CHECK_URL = `${DEALERS_URL}/name`;
export const DEALERS_REDUCE_ALL_URL = `${DEALERS_URL}/reduce/all`;
export const CONFIG_SALES_FTP_HEALTH_URL = '/dealers/api/ftpHealth';

// Devices & Hardware URLs
export const DEVICES_URL = '/devices';
export const DEVICES_API_URL = `${DEVICES_URL}${API}`;
export const DEVICES_FILTER_URL = `${DEVICES_URL}/filter`;
export const DEVICES_REDUCE_URL = `${DEVICES_URL}/reduce`;
const CAMERAS_URL = '/cameras';
export const CAMERAS_API_URL = `${CAMERAS_URL}${API}`;
const HARDWARES_URL = '/hardwares';
export const HARDWARES_API_URL = `${HARDWARES_URL}${API}`;
export const HARDWARES_UNASSIGNED_URL = `${HARDWARES_API_URL}/unassigned`;
const KIOSKS_URL = '/kiosks';
export const KIOSKS_API_URL = `${KIOSKS_URL}${API}`;
export const KIOSKS_FILTER_URL = `${KIOSKS_API_URL}/filter`;
export const KIOSKS_SEARCH_FIND_AVAILABLE_RELAYS_URL = `${KIOSKS_URL}/search/findAvailableRelays`;
export const KIOSKS_SEARCH_FIND_ALL_BY_DEALER_PAYMENT_TYPES_URL = `${KIOSKS_URL}/search/findAllByDealerIdAndPaymentTypes`;
export const KIOSKS_LOCATION_ID_CHECK_URL = `${KIOSKS_URL}/locationId`;
const WHITELIST_URL = '/whiteListedPlates';
export const WHITELIST_API_URL = `${WHITELIST_URL}${API}`;
export const WHITELIST_FILTER_URL = `${WHITELIST_API_URL}/filter`;
export const WHITELIST_EXIST_URL = `${WHITELIST_URL}/exist`;
const GATES_URL = '/gates';
export const GATES_API_URL = `${GATES_URL}${API}`;
export const GATES_FILTER_URL = `${GATES_API_URL}/filter`;
const SCREENSAVERS_URL = '/screensavers';
export const SCREENSAVERS_API_URL = `${SCREENSAVERS_URL}${API}`;
export const SCREENSAVERS_FILTER_URL = `${SCREENSAVERS_API_URL}/filter`;
export const SCREENSAVERS_SEARCH_AVAILABLE_URL = `${SCREENSAVERS_URL}/search/available`;

// Follow-ups URLs
const FOLLOW_UPS_URL = '/followUps';
export const FOLLOW_UPS_API_URL = `${FOLLOW_UPS_URL}${API}`;
export const FOLLOW_UPS_FILTER_URL = `${FOLLOW_UPS_API_URL}/filter`;
export const FOLLOW_UPS_MODEL_URL = `${FOLLOW_UPS_API_URL}/model`;

// Groups URLs
export const GROUPS_URL = '/groups';
export const GROUPS_API_URL = `${GROUPS_URL}${API}`;
export const GROUPS_FILTER_URL = `${GROUPS_URL}/filter`;
export const GROUPS_REDUCE_ALL_URL = `${GROUPS_URL}/reduce/all`;
export const GROUPS_NAME_CHECK_URL = `${GROUPS_URL}/name`;
const USER_GROUPS_URL = '/userGroups';
export const USER_GROUPS_API_URL = `${USER_GROUPS_URL}${API}`;

// Guidelines URLs
const GUIDELINES_URL = '/guidelines';
export const GUIDELINES_API_URL = `${GUIDELINES_URL}${API}`;
export const LATEST_GUIDELINES_URL = '/latestGuidelines';
export const LATEST_GUIDELINES_API_URL = `${LATEST_GUIDELINES_URL}${API}`;
export const LATEST_GUIDELINES_FILTER_URL = `${LATEST_GUIDELINES_URL}/filter`;
export const LATEST_GUIDELINES_SEARCH_BY_DEALER_OR_GROUP_URL = `${LATEST_GUIDELINES_URL}/search/findByDealerIdOrGroupId`;

// Helpdesks URLs
const HELPDESKS_URL = '/helpdesks';
const HELPDESKS_API_URL = `${HELPDESKS_URL}${API}`;
export const HELPDESKS_TICKETS_URL = `${HELPDESKS_API_URL}/tickets`;

// Integrations URLs
export const INTEGRATIONS_URL = {
  PROOVSTATION: '/proovstation',
  BEZAHL_DE: '/bezahl-de'
};
export const KEYLOOP_API_URL = `/keyloop${API}`;

// Interventions URLs
const INTERVENTION_ENTITIES_URL = '/interventionEntities';
export const INTERVENTION_ENTITIES_API_URL = `${INTERVENTION_ENTITIES_URL}${API}`;
export const INTERVENTIONS_STATISTICS_URL = '/interventionStatistics';
export const INTERVENTIONS_STATISTICS_REDUCE_URL = `${INTERVENTIONS_STATISTICS_URL}/reduce`;
const INTERVENTIONS_ENTITIES_STATISTICS_URL = 'interventionEntitiesStatistics';
export const INTERVENTIONS_ENTITIES_STATISTICS_API_URL = `${INTERVENTIONS_ENTITIES_STATISTICS_URL}${API}`;
export const TOP_CONTRIBUTORS_STATISTICS_URL = `${INTERVENTIONS_ENTITIES_STATISTICS_API_URL}/contributors`;

// Jobs URLs
const CRON_JOBS_API_URL = `/cronJobs${API}`;
export const CRON_JOBS_REFRESH_TIME_URL = `${CRON_JOBS_API_URL}/refreshTime`;

// Leads URLs
export const LEADS_URL = '/leads';
export const LEADS_API_URL = `${LEADS_URL}${API}`;
export const LEADS_FILTER_URL = `${LEADS_URL}/filter`;

// Media URLs
const MEDIAS_URL = '/medias';
export const MEDIAS_API_UPLOAD = `${MEDIAS_URL}${API}`;
export const MEDIAS_API_ZIP = `${MEDIAS_URL}${API}/zip`;
export const MEDIAS_API_UPLOAD_URL = `${MEDIAS_URL}${API}/url`;
export const MEDIAS_API_RESTORE = `${MEDIAS_API_UPLOAD}/restore`;
export const MEDIAS_API_IMPORT = `${MEDIAS_API_UPLOAD}/medias/import`;
const MEDIA_LIBRARY_URL = '/mediaLibraryItems';
export const MEDIA_LIBRARY_API_URL = `${MEDIA_LIBRARY_URL}${API}`;

// Mobility URLs
const MOBILITY_URL = '/mobilities';
export const MOBILITY_API_URL = `${MOBILITY_URL}${API}`;
export const MOBILITY_STATISTICS_URL = '/mobilityStatistics';
export const MOBILITY_STATISTICS_REDUCE_URL = `${MOBILITY_STATISTICS_URL}/reduce`;

// Models URLs
export const MODELS_URL = '/models';
export const MODELS_FILTER_URL = `${MODELS_URL}/filter`;
export const MODELS_SEARCH_FIND_BY_ID_URL = `${MODELS_URL}/search/findById`;
export const MODELS_UPDATE_URL = `${MODELS_URL}/update`;

// Offers URLs
export const OFFERS_URL = '/offers';
export const OFFERS_API_URL = '/offers/api';
export const OFFERS_FILTER_URL = `${OFFERS_URL}/filter`;
export const OFFERS_EXPORT_URL = `${OFFERS_API_URL}/export`;

// Parts URLs
export const PARTS_INTERVENTION_STATISTICS_URL = '/partsInterventionStatistics';
export const PARTS_CHAT_STATISTICS_URL = '/partsMessageStatistics';
export const PARTS_CHECKLIST_ADVICE_STATISTICS_URL = '/partsChecklistAdviceStatistics';

// Payments & Payers URLs
const PAYMENTS_URL = '/payments';
export const PAYMENTS_API_URL = `${PAYMENTS_URL}${API}`;
export const PAYMENTS_FILTER_URL = `${PAYMENTS_URL}/filter`;
export const PAYMENTS_REDUCE_URL = `${PAYMENTS_URL}/reduce`;
export const PAYMENTS_EXPORT_URL = `${PAYMENTS_API_URL}/export`;
const PAYERS_URL = '/payers';
export const PAYERS_API_URL = `${PAYERS_URL}${API}`;
export const PAYERS_FILTER_URL = `${PAYERS_URL}/filter`;
export const PAYERS_SEARCH_ALTERABLE_URL = `${PAYERS_URL}/search/alterable`;
export const PAYERS_SEARCH_AVAILABLE_URL = `${PAYERS_URL}/search/available`;
export const PUBLIC_TOKEN_URL = '/publicTokens';
export const PUBLIC_TOKENS_API_URL = `${PUBLIC_TOKEN_URL}${API}`;
const MESSAGING_ACCOUNTS_URL = '/messagingAccounts';
export const MESSAGING_ACCOUNTS_API_URL = `${MESSAGING_ACCOUNTS_URL}${API}`;
export const MESSAGING_ACCOUNTS_FILTER_URL = `${MESSAGING_ACCOUNTS_API_URL}/filter`;

// Question Forms URLs
const QUESTION_MODELS_URL = '/questionFormModels';
export const QUESTION_MODELS_API_URL = `${QUESTION_MODELS_URL}${API}`;
export const QUESTION_MODELS_FILTER_URL = `${QUESTION_MODELS_API_URL}/filter`;
export const QUESTION_MODELS_SEARCH_ALTERABLE_URL = `${QUESTION_MODELS_API_URL}/search/alterable`;
export const QUESTION_MODELS_SEARCH_AVAILABLE_URL = `${QUESTION_MODELS_API_URL}/search/available`;
export const QUESTION_MODELS_SEARCH_BY_DEFAULT_URL = `${QUESTION_MODELS_API_URL}/search/byDefault`;
const QUESTION_MODEL_STATISTICS_URL = '/questionFormQuestionStatistics';
const QUESTION_MODEL_STATISTICS_API_URL = `${QUESTION_MODEL_STATISTICS_URL}${API}`;
export const QUESTION_MODEL_STATISTICS_REDUCE_URL = `${QUESTION_MODEL_STATISTICS_URL}/reduce`;
export const QUESTION_MODEL_STATISTICS_RESPONSE_URL = `${QUESTION_MODEL_STATISTICS_API_URL}/responseStatistics`;
export const QUESTION_MODEL_STATISTICS_EXPORT_URL = `${QUESTION_MODEL_STATISTICS_API_URL}/export`;

// Releases URLs
const RELEASES_URL = '/releases';
export const RELEASES_API_URL = `${RELEASES_URL}${API}`;
export const RELEASES_FILTER_URL = `${RELEASES_API_URL}/filter`;
export const RELEASES_VERSION_URL = `${RELEASES_URL}/version`;
export const RELEASES_TEMPLATE_DOWNLOAD_URL = `${RELEASES_API_URL}/template/download`;

// Scan & Tires URLs
export const TIRES_SCAN_SEARCH_URL = '/scan/tires/search';
export const BODY_SCAN_SEARCH_URL = '/scan/body/search';
export const TIRE_QUOTE_SEARCH_URL = '/quotes/tires/search';
export const TIRE_BRANDS_URL = '/tireBrands/filter';
export const WORKS_SEARCH_URL = '/works/search';

// Self-Service URLs
const SELF_SERVICE_URL = '/selfServices';
export const SELF_SERVICE_API_URL = `${SELF_SERVICE_URL}${API}`;
export const SELF_SERVICE_MODEL_URL = `${SELF_SERVICE_API_URL}/model`;
export const SELF_SERVICE_TOKEN_KIOSK_URL = `${SELF_SERVICE_API_URL}/token/kiosk`;
const SELF_SERVICE_STATISTICS_URL = '/selfServiceStatistics';
const SELF_SERVICE_STATISTICS_API_URL = `${SELF_SERVICE_STATISTICS_URL}${API}`;
export const SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_URL = `${SELF_SERVICE_STATISTICS_API_URL}/contributors`;
export const SELF_SERVICE_STATISTICS_REDUCE_URL = `${SELF_SERVICE_STATISTICS_URL}/reduce`;
const SELF_SERVICE_ADVICE_STATISTICS_URL = '/selfChecklistAdviceStatistics';
export const SELF_SERVICE_ADVICE_STATISTICS_API_URL = `${SELF_SERVICE_ADVICE_STATISTICS_URL}${API}`;
export const SELF_SERVICE_ADVICE_STATISTICS_REDUCE_URL = `${SELF_SERVICE_ADVICE_STATISTICS_URL}/reduce`;
const SELF_SERVICE_PROACTIVE_WORKS_STATISTICS_URL = '/proactiveChecklistAdviceStatistics';
export const SELF_SERVICE_PROACTIVE_WORKS_STATISTICS_API_URL = `${SELF_SERVICE_PROACTIVE_WORKS_STATISTICS_URL}${API}`;
export const SELF_SERVICE_PROACTIVE_WORKS_STATISTICS_REDUCE_URL = `${SELF_SERVICE_PROACTIVE_WORKS_STATISTICS_URL}/reduce`;

// Socket authentication URLs
const SOCKET_AUTH_URL = '/wsToken';
export const SOCKET_AUTH_API_URL = `${SOCKET_AUTH_URL}${API}`;

// Tags URLs
export const TAGS_API_URL = '/tags/api';
export const TAGS_SEARCH_ALTERABLE_URL = `${TAGS_API_URL}/search/alterable`;
export const TAGS_SEARCH_AVAILABLE_URL = `${TAGS_API_URL}/search/available`;

// Templates & Service Headers URLs
export const TEMPLATE_URL = '/templates';
export const TEMPLATE_API_URL = `${TEMPLATE_URL}${API}`;
export const TEMPLATE_FILTER_URL = `${TEMPLATE_URL}/filter`;
export const SERVICE_HEADER_URL = '/serviceHeaders';
export const SERVICE_HEADER_API_URL = `${SERVICE_HEADER_URL}${API}`;
export const TEMPLATE_SEARCH_BY_DEALER_ID_AND_TYPES_URL = `${TEMPLATE_URL}/search/findByDealerIdAndTypes`;

// Users URLs
export const USERS_URL = '/users';
export const USERS_API_URL = '/users/api';
export const USERS_FILTER_URL = `${USERS_URL}/filter`;
export const USERS_SEARCH_FIND_ALL_BY_DEALER_URL = `${USERS_URL}/search/findAllByDealerId`;
export const USERS_USERNAME_CHECK_URL = `${USERS_URL}/username`;
export const USERS_API_BULK_INSERT_SHEET_URL = `${USERS_API_URL}/bulkInsertSheet/url`;
export const USERS_API_FILTER_URL = `${USERS_API_URL}/filter`;
export const USERS_BULK_INSERT_SHEET_URL = `${USERS_URL}/bulkInsertSheet`;
export const USER_GUIDES_URL = '/userGuides';
export const USER_GUIDES_CAMPUS_URL = `${USER_GUIDES_URL}/campus`;

// Vaults URLs
export const VAULTS_URL = '/vaults';
export const VAULTS_API_URL = '/vaults/api';
export const VAULTS_FILTER_URL = `${VAULTS_URL}/filter`;

// Vehicle Check URLs
const VEHICLE_CHECK_MODELS_URL = '/vehicleCheckModels';
export const VEHICLE_CHECK_MODELS_API_URL = `${VEHICLE_CHECK_MODELS_URL}${API}`;

// CCM related endpoints
export const CCM_URL = '/ccm';
export const CCM_API_URL = `${CCM_URL}/api`;

// App & Assets URLs
export const APP_VERSION_URL = '/meta.json';
export const HEALTH_CHECK_API_URL = process.env.REACT_APP_HEALTH_CHECK_URL_BASE;
export const IMAGES_URL = `${process.env.REACT_APP_ASSETS_URL}/public/themes/default/images`;
export const FONT_ICON_URL = `${process.env.REACT_APP_ASSETS_URL}/public/themes/default/font-icons/fb-icon.css`;

export const PROJECTION = {
  PAGE: 'page',
  SLICE: 'slice',
  BASIC: 'basic',
  CONFIG: 'config',
  DETAILS: 'details',
  PAGINATED: 'paginated',
  REMINDERS: 'reminders',
  RESTRICTED: 'restricted',
  IMPORT_MODAL: 'importModal',
  REMINDER_MODAL: 'reminderModal'
};

export const SEARCH_PROXY = {
  ALTERABLE: 'alterable',
  AVAILABLE: 'available'
};
